import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Item } from "./styledComponent";
import SelectForm from "./SelectForm";
import { getAllFormMetaData } from "../../../components/generic/formbuilder/networkservice/FormService";
import SelectVisitReportForm from "./SelectVisitReportForm";

const AddDefaultForms = ({ organizationIdentifier }) => {
  const [forms, setForms] = useState([]);

  useEffect(() => {
    const getForms = async () => {
      const forms = await getAllFormMetaData(
        organizationIdentifier
      );

      if (Array.isArray(forms.data)) {
        const allForms = forms?.data.map((item) => ({
          ...item,
          label: item?.title,
          value: item?.templateCode,
        }));
        setForms(allForms);
      }
    };

    getForms();
  }, [organizationIdentifier]);

  return (
    <>
      <Grid container spacing={2} sx={{ paddingBlock: 2 }}>
        <Grid xs={12} item>
          <Item elevation={0}>
            <h6 className="add-edit-patient-sub-header">Set Default Forms</h6>
          </Item>
        </Grid>

          <Grid xs={12} sm={6} item>
            <Item elevation={0}>
              <SelectVisitReportForm
                organizationIdentifier={organizationIdentifier}
                forms={forms}
              />
            </Item>
          </Grid>
        
        <Grid xs={12} sm={6} item>
            <Item elevation={0}>
              <SelectForm
                formType="Compliance"
                configKey="niramaya.careplan.compliance.form"
                organizationIdentifier={organizationIdentifier}
                forms={forms}
              />
            </Item>
          </Grid>
      </Grid>
    </>
  );
};

export default AddDefaultForms;
